<template>
  <div class="storageInventory fill-page">
    <page-title title="库存与成本" />
    <el-form :inline="true">
      <el-form-item label="仓储">
        <el-select v-model="searchParam.storage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value"
            :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item v-if="data.datetime">
        <el-text>库存数据刷新时间：</el-text>
        <el-text>
          {{ util.parseTime(data.datetime) }}
        </el-text>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" border show-summary :summary-method="summary" :span-method="handleSpanMethod"
      class="fill-table" height="100%">
      <el-table-column prop="storage" label="仓储" show-overflow-tooltip v-if="show.tableStorage" />
      <el-table-column prop="product" label="煤矿品名" show-overflow-tooltip />
      <el-table-column prop="productSpecs" label="规格" width="100" show-overflow-tooltip />
      <el-table-column prop="quantity" label="库存量" show-overflow-tooltip align="right" />
      <el-table-column prop="productPrice" label="煤矿单价" show-overflow-tooltip align="right" />
      <el-table-column prop="transportPrice" label="平均运费（含服务费）" show-overflow-tooltip align="right" />
    </el-table>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()

const data = reactive({
  list: [],
  datetime: null,
})

const show = reactive({
  storageList: [],
  tableStorage: true,
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.storage = null
  searchParam.hasStorage = true
}
resetSearchParam()

const commitFindList = () => {
  api.get('/backend/inventory/list', { params: searchParam }).then(res => {
    data.list = res.list
    data.datetime = new Date(res.data.datetime)
    if (searchParam.hasStorage) {
      show.tableStorage = true
    } else {
      show.tableStorage = false
    }
  })
}

// 合计按列的 prop 对号入座，不按位置写死：「区分仓储」关掉时少一列仓储，0.5.0 起又多了一列规格，按位置排会错位
const summary = ({ columns }) => {
  let quantity = 0
  let productAmount = 0
  let transportAmount = 0
  data.list.forEach(item => {
    quantity = math.plus(quantity, item.quantity)
    productAmount = math.plus(productAmount, math.multiply(item.productPrice, item.quantity))
    transportAmount = math.plus(transportAmount, math.multiply(item.transportPrice, item.quantity))
  })
  return columns.map((column, index) => {
    if (index == 0) {
      return '合计'
    }
    switch (column.property) {
      case 'quantity': return math.formatNumber(quantity)
      case 'productPrice': return quantity ? math.formatNumber(math.divide(productAmount, quantity)) : ''
      case 'transportPrice': return quantity ? math.formatNumber(math.divide(transportAmount, quantity)) : ''
      default: return ''
    }
  })
}
commitFindList()

</script>

<style lang="less"></style>